module.exports = __webpack_public_path__ + "img/bindsuccess.93b35bc1.png";